export default __webpack_public_path__ + "static/media/icon_participle.6a39039f.svg";